export default __webpack_public_path__ + "static/media/proj2_2.704f5937.jpg";